import React from 'react';

import { capitalizeFirstLetter } from '../../utils/utilsFunctions';

import { GoToAppDesktopButtons } from './GoToAppDesktopButtons';
import { MainFunnelButton } from './MainFunnelButton';

import { BaseStepProps } from './BaseStep';

export interface BaseStepButtonsProps extends BaseStepProps {
  onClick: () => void;
  desktopChangeButtonFunction: (isAndroid: boolean) => void;
}

export const BaseStepButtons: React.FC<BaseStepButtonsProps> = (props) => {
  return (
    <>
      {!props.showTwoMainFunnelButtons && props.ctaButtonTitle && (
        <MainFunnelButton
          onClick={props.onClick}
          text={props.ctaButtonTitle}
          disabled={props.isButtonDisabled ?? false}
          id={`mainCta_${capitalizeFirstLetter(props.stepType)}`}
          isLoading={props.isLoading}
        />
      )}
      {props.showTwoMainFunnelButtons && (
        <GoToAppDesktopButtons desktopChangeButtonFunction={props.desktopChangeButtonFunction} />
      )}
    </>
  );
};
